import { commonVars as e } from "./highrise950.mjs";
import t from "./highrise949.mjs";
function i(r) {
  const {
    scrollbarColor: o,
    scrollbarColorHover: l,
    scrollbarHeight: s,
    scrollbarWidth: c,
    scrollbarBorderRadius: a
  } = r;
  return Object.assign(Object.assign({}, e), {
    height: s,
    width: c,
    borderRadius: a,
    color: o,
    colorHover: l
  });
}
const d = {
  name: "Scrollbar",
  common: t,
  self: i
};
export {
  d as default,
  i as self
};
